import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from 'src/app/shared';

@Pipe({
  name: 'dischargeHospital'
})
export class DischargeHospitalPipe implements PipeTransform {

  constructor(private userService: UserService) {}
  transform(value: any[], args: any=""): any {

       if(value)
        {  
          var filterlist = value.filter(item => item.dischargeId == args)
          if(filterlist.length>0) {
            if(filterlist[0].dischargeTo.includes('Unspecified')) 
              return this.userService.translateText('hospital_portal.mytodos.unspecified.option')
            else if(filterlist[0].dischargeTo.includes('Other'))
              return this.userService.translateText('patient_portal.constants.other.label')
          }
              return filterlist[0].dischargeTo;
        }
        
        return "";
  }

}
